import { useState, useCallback, useEffect } from "react";

export const useDashboard = () => {
  const [records, setRecords] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [loadingRecords, setLoadingRecords] = useState(false);

  const fetchUserForms = useCallback(async () => {
    const email = localStorage.getItem("userinfo");
    if (!email) return;

    setLoadingRecords(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/form/user_forms/${email}`
      );
      if (!res.ok) throw new Error(`Failed: ${res.status}`);
      const data = await res.json();
const mapped = (data || []).map((item) => ({
  id:          item.form_id,
  tool:        item.type_name,   // ✅ swapped
  type:        item.tool,        // ✅ swapped
  submittedBy: item.email,
  status:      item.status,
  createdAt:   item.created_at,
  completion:  0,
}));

      setRecords(mapped);
    } catch (err) {
      console.error("Failed to fetch user forms:", err);
    } finally {
      setLoadingRecords(false);
    }
  }, []);

  useEffect(() => {
    fetchUserForms();
  }, [fetchUserForms]);

  const counts = {
    All:       records.length,
    Draft:     records.filter((r) => r.status === "draft").length,
    Submitted: records.filter((r) => r.status === "submitted").length,
    Feedback:  records.filter((r) => r.status === "feedback").length,
    Reviewed:  records.filter((r) => r.status === "reviewed").length,
  };

  const filteredRecords = records.filter((r) => {
    const matchFilter = activeFilter === "All" || r.status?.toLowerCase() === activeFilter.toLowerCase();
    const matchSearch = (r.tool || `Tool #${r.id}`)?.toLowerCase().includes(searchQuery.toLowerCase());
    const matchType   = !typeFilter || r.type === typeFilter;
    return matchFilter && matchSearch && matchType;
  });

  const upsertRecord = useCallback(() => {
    fetchUserForms();
  }, [fetchUserForms]);

  return {
    records,
    counts,
    filteredRecords,
    loadingRecords,
    activeFilter, setActiveFilter,
    searchQuery,  setSearchQuery,
    typeFilter,   setTypeFilter,
    upsertRecord,
    refetchRecords: fetchUserForms, 
  };
};